import styled from "styled-components";

export const VideoPlayer = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1 1 240px;
  border-radius: 16px 0 0 0;
`;

export const SambaEmbed = styled.div`
  width: 100%;
  overflow: hidden;
  /* border-radius: 16px 0 0 0; */
  flex: 1 1 auto;
  flex-direction: column;
  display: flex;

  iframe {
    flex: 1 1 auto;
  }

  @media only screen and (max-width: 1023px) {
    border-radius: 16px 16px 0 0;
  }
`;

/*
${props =>
    props.full
      ? styled.css`
          flex: 1 1 auto;
          flex-direction: column;
        `
      : ""}
*/

export const VimeoEmbed = styled.div`
    background: black;
    width: 100%;
    position: relative;
    overflow: hidden;
    flex: 1;
    border-radius: 16px;

    iframe,
    object,
    embed {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
`;
